
import { Link } from "react-router-dom";
import PublicationCoverImage from "../../../common/catalog/PublicationCoverImage";

export default function Publication({ publication }) {
	const maxLen = 50;
	const title = publication.title.length > maxLen ? publication.title.slice(0, maxLen) + "..." : publication.title;

	return (
		<Link to={`/publication_detail/${publication.id}/`} className="no-underline h-full">
			<div className="flex flex-col bg-white rounded-[10px] p-[10px] h-full">
				{publication.image_url && (
					<>
						<PublicationCoverImage
							src={publication.image_url}
							alt=""
							variant="card"
						/>
						<div className="spacer p-[10px]"></div>
					</>
				)}
				<div className="font-Vazir-700 text-[16px] text-midGray">{title}</div>
				<div className="spacer p-[5px]"></div>
				<div className="flex flex-row items-center mt-auto">
					{publication.profile_detail?.avatar_url && (
						<>
							<div className="w-[40px] aspect-square">
								<img
									src={publication.profile_detail?.avatar_url}
									alt=""
									className="w-full h-full object-cover rounded-full"
								/>
							</div>
							<div className="spacer p-[5px]"></div>
						</>
					)}
					<div>
						<div className="font-Vazir-300 text-[14px] text-darkBlue">{publication.profile_detail?.name}</div>
						<div className="spacer p-[2px]"></div>
						<div className="font-Vazir-300 text-[14px] text-darkBlue" dir="ltr">{publication.j_create_date}</div>
					</div>
				</div>
			</div>
		</Link>
	)
}
